import { createSlice } from "@reduxjs/toolkit";
import getOwnerMerchantFromCookie from "../../utils/Jwt";

export const authenticationSlice = createSlice({
  name: "authentication",
  reducers: {
    setLoggedInMerchant: (state) => {
      const merchant = getOwnerMerchantFromCookie();
      if (merchant) {
        state.loggedInMerchant = merchant;
        state.isAuthenticated = true;
      }
    },
    setMerchantDetails: (state, action) => {
      state.merchantDetails = action.payload;
    },
  },
  initialState: {
    isAuthenticated: false,
    loggedInMerchant: "",
    merchantDetails: {},
  },
});

// Action creators are generated for each case reducer function
export const { setLoggedInMerchant, setMerchantDetails } = authenticationSlice.actions;

export default authenticationSlice.reducer;
